<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <v-sheet class="px-3" v-if="!!storeAggregate.rootData && !!storeDetail.uidItem">
          <BaseFieldString
              v-model="storeAggregate.rootData[storeDetail.uidItem].name"
              label="Name"
              class="mt-3"
          ></BaseFieldString>
          <BaseFieldString
              v-model="storeAggregate.rootData[storeDetail.uidItem].alias"
              label="ProductReplica ID"
              class="mt-3"
          ></BaseFieldString>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "ProductReplicaDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'ProductReplicaDetail'},
    dtoDetailQuery: {default: 'ProductReplicaDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ProductReplicaActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'ProductReplicaSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'ProductReplicaValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'ProductReplicaBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'ProductReplicaTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    BaseFieldCheck,
    BaseFieldString,
    CommonDetail,
  },

  computed: {},

  methods: {}
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>